import { useEffect as e } from "/home/runner/work/oko-web/oko-web/node_modules/react/index.js";
//#region src/lib/hooks/useKeyboardListener.ts
var t = (t, n, r, i) => {
	let a = t === void 0 ? document : t;
	e(() => (a?.addEventListener("keydown", n), a?.addEventListener("keyup", r), () => {
		a?.removeEventListener("keydown", n), a?.removeEventListener("keyup", r);
	}), [a, i]);
};
//#endregion
export { t as useKeyboardListener };
